import { RestHandler, MockedRequest, DefaultRequestBody, rest } from 'msw';
import { DB } from '../db';

const routes: RestHandler<MockedRequest<DefaultRequestBody>>[] = [];

routes.push(
    /**
     * GET /industries
     * Gets all industries
     */
    rest.get('/industries', (req, res, ctx) => {
        const search = req.url.searchParams.get('search');

        let industries = DB.GetIndustries();
        let totalItems = industries.length;

        if (search) {
            industries = industries.filter((i) => i.name.toLowerCase().includes(search.toLowerCase()));
            totalItems = industries.length;
        }

        return res(ctx.delay(), ctx.status(200), ctx.json({ data: industries, totalItems, count: industries.length }));
    })
);

export { routes };
